/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import { call, put, select } from "redux-saga/effects";
import { push } from "connected-react-router";
import * as userAction from "../actions/user";
import api from "../services/httpUtilities/httpService";
import httpErrorHelpers from "../services/httpUtilities/httpErrorHelpers";
import Toast from "../utils/Toast";
import OrderManager from "../utils/OrderManager";

function* watcherGetUserCartItemRequest({ payload }) {
  try {
    const response = yield call(api.getUserCartItem);

    yield put(userAction.getUserCartItemSuccess(response.data));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.getUserCartItemFailure);
  }
}

function* watcherDeleteUserCartItemRequest({ cartID }) {
  try {
    const response = yield call(api.deleteUserCartItem, cartID);
    const { success, messages, cart } = response.data;
    if (success) {
      Toast.success(messages ? messages[0].text : "");
    }
    yield put(userAction.deleteUserCartItemSuccess(cart));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.deleteUserCartItemFailure);
  }
}

function* watcherApplyUserCartWalletRequest({ walletData }) {
  try {
    const response = yield call(api.applyUserCartWallet, walletData);
    const { success, messages, cart } = response.data;
    if (success) {
      Toast.success(messages ? messages[0].text : "");
    }
    yield put(userAction.applyUserCartWalletSuccess(cart));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.applyUserCartWalletFailure);
  }
}

function* watcherApplyUserCartPointRequest({ pointData }) {
  try {
    const response = yield call(api.applyUserCartPoint, pointData);
    const { success, messages, cart } = response.data;
    if (success) {
      Toast.success(messages ? messages[0].text : "");
    }
    yield put(userAction.applyUserCartPointSuccess(cart));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.applyUserCartPointFailure);
  }
}

function* watcherAddUserCartFoodRequest({ foodID, foodData }) {
  try {
    const response = yield call(api.addUserCartFood, foodID, foodData);
    const { success, messages, cart } = response.data;
    if (success) {
      Toast.success(messages ? messages[0].text : "");
      yield put(userAction.addUserCartFoodSuccess(cart));
    }
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.addUserCartFoodFailure);
  }
}

function* watcherEditUserCartFoodRequest({ cartID, foodData }) {
  try {
    const response = yield call(api.updateUserCartFood, cartID, foodData);
    const { success, messages, cart } = response.data;

    if (success) {
      Toast.success(messages ? messages[0].text : "");

      yield put(userAction.editUserCartFoodSuccess(cart));
    }
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.editUserCartFoodFailure);
  }
}

function* watcherUpdateUserCartFoodDeliveryRequest({ cartID, deliveryStatus }) {
  try {
    // yield put(userAction.setDeliveryStatus(cartID, deliveryStatus));
    const response = yield call(api.updateUserCartFoodDelivery, cartID);
    const { success, messages, cart } = response.data;

    if (success) {
      yield put(userAction.updateUserCartFoodDeliverySuccess(cart));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      userAction.updateUserCartFoodDeliveryFailure
    );
  }
}

function* watcherCheckoutUserCartRequest({ checkoutData }) {
  try {
    const response = yield call(api.checkoutUserCart, checkoutData);

    const { success, order } = response.data;

    if (success) {
      yield put(userAction.checkoutUserCartSuccess(order));
      yield put(userAction.setOrderIndicator());
    }
  } catch (error) {
    const { status, data } = error.response;
    if (
      status === 400 &&
      data.error &&
      data.error.type === "insufficient-wallet-balance"
    ) {
      yield put(userAction.setBalanceError(true));
    } else {
      yield call(httpErrorHelpers, error, userAction.checkoutUserCartFailure);
    }
  }
}

function* watcherGetUserOrderDetailRequest({ orderID }) {
  try {
    const response = yield call(api.getUserOrderDetail, orderID);

    yield put(userAction.getUserOrderDetailSuccess(response.data));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.getUserOrderDetailFailure);
  }
}

function* watcherUpdateUserOrderTableRequest({ tableData }) {
  try {
    const response = yield call(api.updateUserOrderTable, tableData);
    const { success, messages, cart } = response.data;
    if (success) {
      Toast.success(messages ? messages[0].text : "");
    }
    yield put(userAction.updateUserOrderTableSuccess(cart));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.updateUserOrderTableFailure);
    yield put(push("/shop/cart"));
  }
}

function* watcherGetUserOrderListRequest({ pageNumber = 1 }) {
  try {
    const response = yield call(api.getUserOrderList, pageNumber);
    const { items, _meta } = response.data;
    yield put(userAction.getUserOrderListSuccess(items, _meta));
    yield put(userAction.clearOrderIndicator());
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.getUserOrderListFailure);
  }
}

function* watcherCancelUserOrderRequest({ orderID }) {
  try {
    const response = yield call(api.cancelUserOrder, orderID);
    const { success, messages } = response.data;
    if (success) {
      Toast.success(messages ? messages[0].text : "");
    }
    yield put(userAction.cancelUserOrderSuccess());
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.cancelUserOrderFailure);
  }
}

function* watcherPostUserOrderPaymentRequest({ data, orderID }) {
  try {
    const response = yield call(api.postUserOrderPayment, orderID, data);

    const { success, item } = response.data;

    yield put(userAction.postUserOrderPaymentSuccess(item, success));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.postUserOrderPaymentFailure);
  }
}

function* watcherUpdateUserOrderPaymentRequest({ paymentID, data }) {
  try {
    const response = yield call(api.updateUserOrderPayment, paymentID, data);

    const { success, messages, item } = response.data;

    // success ? Toast.success(messages ? messages[0].text : "") : Toast.error(messages ? messages[0].text : "");

    yield put(userAction.updateUserOrderPaymentSuccess(item));
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      userAction.updateUserOrderPaymentFailure
    );
  }
}

function* watcherGetUserQueueItemRequest({ payload }) {
  try {
    const response = yield call(api.getUserQueueItem);
    yield put(userAction.getUserQueueListSuccess(response.data));
  } catch (error) {
    yield call(httpErrorHelpers, error, userAction.getUserQueueListFailure);
  }
}

function* watcherGetUserQueueReadyItemRequest({ payload }) {
  try {
    const response = yield call(api.getUserQueueReadyItem);
    yield put(userAction.getUserQueueReadyItemSuccess(response.data));
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      userAction.getUserQueueReadyItemFailure
    );
  }
}

function* watcherGetUserQueueCompleteItemRequest({ payload }) {
  try {
    const response = yield call(api.getUserQueueCompleteItem);
    yield put(userAction.getUserQueueCompleteItemSuccess(response.data));
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      userAction.getUserQueueCompleteItemFailure
    );
  }
}

function* watcherSetOrderIndicator() {
  OrderManager.setOrderIndicator();
}

function* watcherClearOrderIndicator() {
  OrderManager.removeOrderIndicator();
}

function* watcherUpdateOrderSummaryTable({ orderID, tableData }) {
  try {
    const response = yield call(
      api.updateOrderSummaryTable,
      orderID,
      tableData
    );
    const { success, order, messages } = response.data;

    if (success === true) {
      Toast.success(messages ? messages[0].text : "");
      yield put(userAction.updateOrderSummaryTableSuccess());
      yield put(userAction.getUserOrderDetailRequest(order.id));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      userAction.updateOrderSummaryTableFailure
    );
  }
}

export {
  watcherGetUserCartItemRequest,
  watcherDeleteUserCartItemRequest,
  watcherApplyUserCartWalletRequest,
  watcherApplyUserCartPointRequest,
  watcherAddUserCartFoodRequest,
  watcherEditUserCartFoodRequest,
  watcherUpdateUserCartFoodDeliveryRequest,
  watcherCheckoutUserCartRequest,
  watcherGetUserOrderDetailRequest,
  watcherUpdateUserOrderTableRequest,
  watcherGetUserOrderListRequest,
  watcherCancelUserOrderRequest,
  watcherUpdateUserOrderPaymentRequest,
  watcherGetUserQueueItemRequest,
  watcherGetUserQueueReadyItemRequest,
  watcherGetUserQueueCompleteItemRequest,
  watcherPostUserOrderPaymentRequest,
  watcherSetOrderIndicator,
  watcherClearOrderIndicator,
  watcherUpdateOrderSummaryTable
};



// WEBPACK FOOTER //
// ./src/sagas/user.js